import { useNavigate } from "react-router-dom"
import ApiService from "../../services/apiService"
import Add from "../table/Add"
import { use, useEffect,useState } from "react"
import { method } from "lodash"
import { toast } from "react-toastify"
import { validate } from "uuid"
import validation from "ajv/dist/vocabularies/validation"


const AddPumpingStationHistory = () =>{

       const navigate = useNavigate();
       const [pumpingStation,setPumpingStation] = useState<any> ();


       const handleSubmit =async (data:any) =>{
             
        try{
             const response = await ApiService.axiosApi(`/pumpingstation/history`,{
                 method:'POST',
                 data:data
             });
             if(response.success){
                 toast.success(response.message || "History Added Successfully" )
                 navigate(-1)
             }else{
                 toast.error(response.message || 'Unable To Add History ')
             }
        }catch(e:any){
             console.log(e.error || 'unable to add history ')
        }
          
       }

       useEffect(()=>{
             
        const fecthPumpingStaion = async() =>{
              
            try{
                 const response = await ApiService.axiosApi('/pumpingstation',{
                     method:'GET',
                     params:{
                        pageNumber :0,
                        pageSize:0
                   }
                 })
                 if(response.success){
                   
                    setPumpingStation(response.data.data)
                 }else{
                     console.log(response.message || 'Unable to fectrh Pumpiung station')
                 }
            }catch(e:any){
                 console.log(e.message || 'uanble to get Pumping Station')
            }

        }

        fecthPumpingStaion();
       },[])
     
    return (
         <>
            <Add
               title ={'Add Pumping Station History'}
               parent ={'Pumping station History'}
               onSubmit={handleSubmit}

               fields ={[
                   {
                     name:'DailyVolume',
                     label:'Pumping Volume',
                     type:'text',
                     validation:{required:'Daily Volume is Required'}
                   },
                   {
                     name:"PumpNumber",
                     label:'Pump Number',
                     type:'text',
                     validation:{required:"Pump Number is Required"}
                   },
                   {
                    name:'DateTime',
                    label:'Date & Time',
                    type:'dateTime',
                    validation:{ required:"Date & Time is Required" }
                  },
                   {
                      name:'Name',
                      label:'Pumping Station',
                      isDropdown:true,
                      dropdownData:pumpingStation,
                      dropdownLabel:'name',
                      idFieldName:'PumpingStationId'
                   },
                  
               ]}
            />
         </>
    ) 
}

export default AddPumpingStationHistory